import {User} from 'yougile-model'
import {Accounts} from '../client/accounts'

export class UserUtils {
  public static sortByName(users: User[]): User[] {
    return !users
      ? []
      : users
          .filter(u => !!u)
          .map(u => ({user: u, name: Accounts.getName(u.id).toLowerCase()}))
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map(un => un.user)
  }
}
